import { Capacitor } from "@capacitor/core";
import { AppleLogo, GooglePlayLogo } from "@phosphor-icons/react";
import { trackSiteEvent } from "../lib/analytics";
import { APP_STORE_URL, PLAY_STORE_URL, ANDROID_LIVE } from "../lib/appStores";

// Replaces the old AppStoreWaitlist (apps were "coming soon" — now live).
// Renders nothing inside the native app itself.
export default function GetTheAppCard({ compact = false }) {
  if (Capacitor.isNativePlatform()) return null;
  return (
    <section
      className={`rounded-2xl border border-border bg-primary/5 ${compact ? "p-5" : "p-6 sm:p-8"}`}
      data-testid="get-the-app-card"
    >
      <div className="text-[11px] font-bold tracking-widest text-primary uppercase mb-2">
        Get the app
      </div>
      <h2 className={`font-display font-bold ${compact ? "text-lg" : "text-2xl sm:text-3xl"} leading-tight`}>
        TruckTrackr is in your pocket now.
      </h2>
      <p className="text-sm text-muted-foreground mt-2 max-w-xl">
        Live truck map, follow your favorites, and get pinged when they're
        open near you — free on the App Store{ANDROID_LIVE ? " and Google Play" : ""}.
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackSiteEvent("cta_app_store")}
          className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-foreground text-background text-sm font-semibold hover:opacity-90 transition-opacity"
          data-testid="get-app-ios"
        >
          <AppleLogo weight="fill" className="h-4 w-4" />
          App Store
        </a>
        {ANDROID_LIVE && (
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackSiteEvent("cta_google_play")}
            className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-foreground text-background text-sm font-semibold hover:opacity-90 transition-opacity"
            data-testid="get-app-android"
          >
            <GooglePlayLogo weight="fill" className="h-4 w-4" />
            Google Play
          </a>
        )}
      </div>
    </section>
  );
}
